const isLocalhost = window.location.hostname === "localhost";
// const isLiveWebsite = window.location.hostname === "www.djpsmbdin.edu.pk";
const isLiveWebsite = window.location.hostname === "aspire.jueducation.com";
const isLocalServer = window.location.hostname === "192.168.1.99";
const isLiveAccounts = window.location.hostname === "aspire.jueducation.com";
const isKipsAccount = window.location.hostname === "kips.jueducation.com";
let base_url;
let path;
let StudentImagePath;
let StaffImagePath;
let images;
let assets;
let root;
let admin_path;
let title;
let favicon;
let logo;

if (isLocalhost) {
  //base_url = "http://localhost:52476/api/";
  // StaffImagePath = "http://localhost:52476/staff_images/";
  // StudentImagePath = "http://localhost:52476/student_images/";
  // images = "http://localhost:52476/images/";
  // assets = "http://localhost:52476/assets/";
  // root = "http://localhost:52476/";
  // title = "Localhost"
  // favicon = "/AspireFavicon.png";
  // logo = "/AspireLogo.png";

  base_url = "https://newaspireapi.jueducation.com/api/";
  // StaffImagePath = "https://aspireapi.jueducation.com/staff_images/";
  // StudentImagePath = "https://aspireapi.jueducation.com/student_images/";
  // images = "https://aspireapi.jueducation.com/images/";
  // assets = "https://aspireapi.jueducation.com/assets/";
  // root = "https://aspireapi.jueducation.com/";

  // base_url = "https://kipsapi.jueducation.com/api/";
  StaffImagePath = "https://kipsapi.jueducation.com/staff_images/";
  StudentImagePath = "https://kipsapi.jueducation.com/student_images/";
  images = "https://kipsapi.jueducation.com/images/";
  assets = "https://kipsapi.jueducation.com/assets/";
  root = "https://kipsapi.jueducation.com/";
  title = "Kips";
  favicon = "/KipsFavicon.png";
  logo = "/KipsLogo.png";
} else if (isKipsAccount) {
  base_url = "https://kipsapi.jueducation.com/api/";
  StaffImagePath = "https://kipsapi.jueducation.com/staff_images/";
  StudentImagePath = "https://kipsapi.jueducation.com/student_images/";
  images = "https://kipsapi.jueducation.com/images/";
  assets = "https://kipsapi.jueducation.com/assets/";
  root = "https://kipsapi.jueducation.com/";
  title = "Kips";
  favicon = "/KipsFavicon.png";
  logo = "/KipsLogo.png";
} else if (isLiveWebsite) {
  base_url = "https://aspireapi.jueducation.com/api/";
  StaffImagePath = "https://aspireapi.jueducation.com/staff_images/";
  StudentImagePath = "https://aspireapi.jueducation.com/student_images/";
  images = "https://aspireapi.jueducation.com/images/";
  assets = "https://aspireapi.jueducation.com/assets/";
  root = "https://aspireapi.jueducation.com/";
  title = "Aspire";
  favicon = "/AspireFavicon.png";
  logo = "/AspireLogo.png";
} else if (isLiveAccounts) {
  base_url = "https://aspireapi.jueducation.com/api/";
  StaffImagePath = "https://aspireapi.jueducation.com/staff_images/";
  StudentImagePath = "https://aspireapi.jueducation.com/student_images/";
  images = "https://aspireapi.jueducation.com/images/";
  assets = "https://aspireapi.jueducation.com/assets/";
  root = "https://aspireapi.jueducation.com/";
  title = "Aspire";
  favicon = "/AspireFavicon.png";
  logo = "/AspireLogo.png";
}

//SeRveR*324*
// Registration No: 8710//34402-7260112-2//12345678

/*For AGS SchoolAdminAdmin*324**/
const config = {
  base_url,
  path,
  StudentImagePath,
  StaffImagePath,
  assets,
  root,
  images,
  title,
  favicon,
  logo,
  admin_path,
  date_format: "DD/MM/YYYY",
  date_format_input: "YYYY-MM-DD",
};

export default config;
